<template>
    <div class="overflow-hidden border border-gray-300 rounded-md">
        <div class="flex items-center bg-gray-100">
            <div class="w-5/12 py-2 px-2 font-bold">Имя</div>
            <div class="w-5/12 py-2 font-bold">Телефон</div>
            <div class="w-5/12 py-2 font-bold">LayoutId(чай-чай)</div>
            <div class="w-5/12 py-2 font-bold">LayoutId(нетмонет)</div>
            <div class="w-2/12 py-2 font-bold">На смене</div>
            <div class="w-2/12 py-2 font-bold">Активен</div>
        </div>

        <div
            v-for="item in list"
            :key="item.id"
            class="flex items-center h-10 py-4 border-t border-gray-300"
        >
            <div class="w-5/12 truncate px-2">
                <span
                    class="text-purple-700 cursor-pointer hover:underline"
                    :title="item.name"
                    @click="$emit('select', item.id)"
                >
                    {{ item.name }}
                </span>
            </div>

            <div class="w-5/12 py-2">{{ item.phone }}</div>
            <div class="w-5/12 py-2">{{ item.tips_layout_id }}</div>
            <div class="w-5/12 py-2">{{ item.tips_layout_id_new }}</div>
            <div class="w-2/12">
                <CBadge :color="item.online ? 'success' : 'secondary'">
                    {{ item.online ? "Да" : "Нет" }}
                </CBadge>
            </div>
            <div class="w-2/12">
                <CBadge :color="item.enabled ? 'success' : 'secondary'">
                    {{ item.enabled ? "Да" : "Нет" }}
                </CBadge>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},

        props: {
            list: {
                type: Array,
                default: () => [],
            },
        },
    };
</script>
